import { getRequestConfiguration } from "../utils/headerHelper";
import Axios from "../utils/http-request";
import { AxiosErrorResponse } from "../interface/api_request";

export const apiGetFacilityTimesheet = async (page: string, filter: string) => {
  const cfg = await getRequestConfiguration({
    "Content-Type": "application/x-www-form-urlencoded",
  });
  try {
    const uri = `/timesheets?page=${page}&${filter}`;
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetTimesheetById = async (values: { timesheetId: string }) => {
  try {
    const uri = `/timesheets/timesheet/${values.timesheetId}`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetAllMedicTimesheetById = async (values: {
  medicId: string;
}) => {
  try {
    const uri = `/timesheets/medic/${values.medicId}`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiFlagTimeSheet = async (fieldValues: {
  flag_note: string;
  employeeId: string;
}) => {
  const formData = new URLSearchParams();
  try {
    const uri = `/timesheets/flag/${fieldValues.employeeId}`;
    // Append all form fields to FormData
    Object.entries(fieldValues).forEach(([key, value]) => {
      if (value !== undefined) {
        formData.append(key, value.toString());
      }
    });
    const cfg = getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.put(uri, formData, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiResoleFlaggedTimeSheet = async (fieldValues: {
  timesheetId: string;
}) => {
  const formData = new URLSearchParams();
  try {
    const uri = `/timesheets/resolve/${fieldValues.timesheetId}`;
    // Append all form fields to FormData
    Object.entries(fieldValues).forEach(([key, value]) => {
      if (value !== undefined) {
        formData.append(key, value.toString());
      }
    });
    const cfg = getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.patch(uri, {}, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};
